export function buildAssignmentGroups({
  groups,
  assignmentsByRole,
  blockedSlots,
  publishedShiftsByRole,
  handlers,
}) {
  return groups.map((group) => ({
    ...group,
    rows: group.rows.map((row) => ({
      ...row,
      assignments:
        assignmentsByRole && row.roleKey in assignmentsByRole
          ? assignmentsByRole[row.roleKey]
          : row.assignments || [],
      blocked:
        blockedSlots && row.roleKey in blockedSlots
          ? !!blockedSlots[row.roleKey]
          : !!row.blocked,
      publishedShifts:
        publishedShiftsByRole && row.roleKey in publishedShiftsByRole
          ? publishedShiftsByRole[row.roleKey]
          : row.publishedShifts || [],
      ...handlers(row.roleKey),
    })),
  }));
}